"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.actions = exports.types = void 0;
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable default-param-last  cambio   */
// const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";
const react_1 = __importDefault(require("react"));
const dynamic_1 = __importDefault(require("next/dynamic"));
let Modal = null;
const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";
exports.types = {
    INIT_ANCHOR_MODAL_LISTENER: "MODAL/INIT_ANCHOR_MODAL_LISTENER",
    ADD_MODAL: "MODAL/ADD_MODAL",
    SET_MODAL_HISTORY: "MODAL/SET_MODAL_HISTORY",
};
exports.actions = {
    /* SSEO */
    initAnchorModalListener: () => ({
        type: exports.types.INIT_ANCHOR_MODAL_LISTENER,
    }),
    addModal: (data) => ({
        type: exports.types.ADD_MODAL,
        data,
    }),
    setModalHistory: (data) => ({
        type: exports.types.SET_MODAL_HISTORY,
        data,
    }),
};
const initialState = {
    modalImport: null,
    modalHistory: [],
    Modal: null,
};
const ModalReducer = (state = initialState, action) => {
    switch (action.type) {
        case HYDRATE: {
            const { modals } = action.payload;
            return Object.assign(Object.assign({}, state), modals);
        }
        case exports.types.ADD_MODAL: {
            if (!state.Modal) {
                const modalImport = Promise.resolve().then(() => __importStar(require("@/bit/components/components.modal")));
                Modal = (0, dynamic_1.default)(() => modalImport, { ssr: false });
                const modalInstance = react_1.default.createElement(Modal, null);
                return Object.assign(Object.assign({}, state), { modalImport, Modal: modalInstance });
            }
            return state;
        }
        case exports.types.SET_MODAL_HISTORY: {
            return Object.assign(Object.assign({}, state), { modalHistory: [...action.data] });
        }
        default:
            return Object.assign({}, state);
    }
};
exports.default = ModalReducer;
//# sourceMappingURL=index.js.map